var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,16 L3,16 C2.45,16 2,15.55 2,15 L2,3 C2,2.45 2.45,2 3,2 L15,2 C15.55,2 16,2.45 16,3 L16,15 C16,15.55 15.55,16 15,16 Z M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z",
    id: "path-checkbox-unselected"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---02.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Register---Step-1",
    transform: "translate(-378.000000, -463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(343.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Checkbox",
    transform: "translate(35.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-checkbox-unselected",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-checkbox-unselected"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/toggle/check_box_outline_blank_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-checkbox-unselected)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -3.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionUnselected);
export default __webpack_public_path__ + "static/media/option-unselected.905111d1.svg";
export { ForwardRef as ReactComponent };